import { privateFetch } from "api/privateFetch";

/**
 * Get Free Slots
 * @param {{csmId: string; payload: Object}} Payload CSM ID & Payload
 * @returns {Promise<Object[]>} Response
 */
const scheduleSession = async ({ csmId, payload }) => {
  const { data } = await privateFetch.post(
    `csm/${csmId}/schedulesession`,
    payload
  );

  return data;
};

export default scheduleSession;
